import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const UnLinkButtonStyle = () => ({
  padding: 0,
  '&.Mui-disabled': {
    border: 'none'
  }
});

const DetailBoxLayoutStyle = ({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `"title"
        "content"
        "button"`,
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '16px',
  padding: '32px',
  gap: '24px',
  marginBottom: '24px',
  [theme.breakpoints.up('sm')]: {
    gridTemplateAreas: `"title button"
        "content content"`,
    padding: '24px'
  }
});

const TitleAreaStyle = ({ theme }) => ({
  gridArea: 'title',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
    gap: '16px'
  }
});

const ButtonAreaStyle = () => ({
  gridArea: 'button',
  justifyContent: 'end',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '8px'
});

const ContentAreaStyle = ({ theme }) => ({
  gridArea: 'content',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '24px',
  justifyContent: 'space-between',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr'
  }
});

export const DetailBoxLayoutStyled = styled(Box)(DetailBoxLayoutStyle);
export const TitleAreaStyled = styled(Stack)(TitleAreaStyle);
export const ButtonAreaStyled = styled(Stack)(ButtonAreaStyle);
export const ContentAreaStyled = styled(Box)(ContentAreaStyle);
export const UnLinkButtonStyled = styled(Button)(UnLinkButtonStyle);
